// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Theme__Color$PrezzeeRibbon from "../../../theme/Theme__Color.bs.js";

function t(overlayColorOpt, decoColorOpt, colorOpt, param) {
  var overlayColor = overlayColorOpt !== undefined ? overlayColorOpt : Theme__Color$PrezzeeRibbon.purple700;
  var decoColor = decoColorOpt !== undefined ? decoColorOpt : Theme__Color$PrezzeeRibbon.purple400;
  var color = colorOpt !== undefined ? colorOpt : Theme__Color$PrezzeeRibbon.white;
  return {
          overlayColor: overlayColor,
          decoColor: decoColor,
          color: color
        };
}

export {
  t ,
}
/* Theme__Color-PrezzeeRibbon Not a pure module */
